import type { ReactNode } from "react";
import type { MarkdownPreviewProps } from "@uiw/react-markdown-preview";
import { FullScreenMaximizeRegular } from "@fluentui/react-icons";
import styles from "../../MarkdownContent.module.scss";

interface ITableRendererProps {
  expandTableLabel: string;
  setExpandedTableProps: (tableProps: React.TableHTMLAttributes<HTMLTableElement> | null) => void;
}

export function createTableRenderer({
  expandTableLabel,
  setExpandedTableProps,
}: ITableRendererProps): Pick<NonNullable<MarkdownPreviewProps["components"]>, "table"> {
  return {
    table: (props: React.TableHTMLAttributes<HTMLTableElement>): ReactNode => {
      const tableClassName = props.className ? `${props.className} table table-complex` : "table table-complex";

      return (
        <div className={styles.tableContainer}>
          <div className={styles.tableToolbar}>
            <button
              type="button"
              className={styles.tableToggleButton}
              onClick={(): void =>
                setExpandedTableProps({
                  ...props,
                  className: tableClassName,
                })
              }
              aria-label={expandTableLabel}
            >
              <FullScreenMaximizeRegular />&nbsp;{expandTableLabel}
            </button>
          </div>
          <div className={styles.tableWrapper} role="region" aria-label="Scrollable table">
            <table
              {...props}
              className={tableClassName}
            />
          </div>
        </div>
      );
    },
  };
}

